export default __webpack_public_path__ + "static/media/jump.35c2c456.mp3";